import React, { memo, useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import Filters from "./Filters";
import Insights from "./Insights";
import ResultsTable from "./ResultsTable";
import dayjs from "dayjs";
import { fetchConvos } from "services/elvis";
import { toast } from "react-toastify";
import { getAllEvaUsers } from "services/userServices";

const ElvisConversations = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        start: dayjs().subtract(3, 'month'),
        end: dayjs(),
        query: '',
        users: [],
        rating: new Set()
    });

    const handleSearch = async () => {
        setLoading(true);
        try {
            const res = await fetchConvos(filters);
            if (res && res.status == 200) {
                const users = await getAllEvaUsers();
                const userMap = users.reduce((acc, curr) => { acc[curr.userId] = curr.name; return acc; }, {});
                let data = res.data;
                if (users) {
                    data = data.map(x => {
                        return {
                            ...x,
                            user: userMap[x.createdBy] ?? "Unknown"
                        }
                    });
                }
                setData(data)
            }
        } catch (err) {
            toast.error('Something went wrong!', err)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => (async () => await handleSearch())(), [])

    return (
        <>
            <Row className="g-3 mb-3">
                <Filters filters={filters} setFilters={setFilters} handleClick={handleSearch} />
            </Row>
            <Row className="g-3 mb-3">
                <Insights data={data} loading={loading} />
            </Row>
            <Row className="g-3 mb-3">
                <ResultsTable data={data} loading={loading} />
            </Row>
        </>
    )
}

export default memo(ElvisConversations);